import dom from '../../utils/dom';
import DeleteCartItemButton, { OnCompleteCallbackArgs } from '../DeleteCartItemButton';
import initPaymentPlanSelection from '../payment-plans/initPaymentPlanSelection';
import initAppliedPaymentPlan from '../payment-plans/initAppliedPaymentPlan';
import Messaging from '../../tnew/ui/Messaging';
import { IRemoveFromCartAnalytics } from '../../analytics/types';
import AnalyticsService from '../../analytics/AnalyticsService';

interface SharedCartItemsProps {
  isPaymentPlanSelectionVisible: boolean;
  isPaymentPlanApplied: boolean;
  removeFromCartAnalyticsMap?: { [lineItemId: string]: IRemoveFromCartAnalytics; };
}

type TnewWindowUi = { messaging: typeof Messaging };

const { messaging }: TnewWindowUi = window.tnew.ui;

function initSharedCartItems({ isPaymentPlanSelectionVisible, isPaymentPlanApplied, removeFromCartAnalyticsMap }: SharedCartItemsProps) {
  const removeFromCartAnalytics = new Map(Object.entries(removeFromCartAnalyticsMap || {}));

  window.history.scrollRestoration = 'manual';

  dom.findAll('.tn-cart__btn-remove').forEach((el) => {
    const handleDeleteCompleted = async ({ redirectTo }: OnCompleteCallbackArgs) => {
      const lineItemId = el.getAttribute('data-tn-line-item-id');

      if (lineItemId) {
        const removeItemAnalytics = removeFromCartAnalytics.get(lineItemId);

        if (removeItemAnalytics) {
          await AnalyticsService.trackRemoveFromCart(removeItemAnalytics);
        }
      }

      window.location.href = redirectTo;
      if (window.location.hash) {
        window.history.replaceState(null, document.title, window.location.pathname + window.location.search);
        window.location.reload();
      }
    };

    new DeleteCartItemButton(el as HTMLButtonElement, handleDeleteCompleted);
  });

  if (messaging.testHasErrorMessages()) {
    window.setTimeout(() => messaging.focusUserOnMessages());
  }

  if (isPaymentPlanApplied) {
    initAppliedPaymentPlan();
  } else if (isPaymentPlanSelectionVisible) {
    initPaymentPlanSelection();
  }
}

export default initSharedCartItems;
